import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { ModalService } from '../services/modal/modal.service';
import { UserInfo } from '../models/user/user-info';
import { STORAGE_KEYS } from '../enums/commission';
import { VISIBILITY_MAP } from '../constants/visibility';
import { ModalInfos } from '../models/modal/modal-infos';
import { Title } from '@angular/platform-browser';
import { VISIBILITY as ENUM_VISIBILITY } from '../enums/visibility';

export const waitForUserInfo = (): Promise<UserInfo> => {
  return new Promise((resolve) => {
    const checkUserInfo = () => {
      const userInfo = localStorage.getItem(STORAGE_KEYS.USER_INFO);
      if (userInfo) {
        resolve(JSON.parse(userInfo));
      } else {
        setTimeout(checkUserInfo, 100);
      }
    };
    checkUserInfo();
  });
};

export const waitForProducer = (): Promise<UserInfo> => {
  return new Promise((resolve) => {
    const checkProducerInfo = () => {
      const producerInfo = localStorage.getItem(STORAGE_KEYS.PRODUCER);
      if (producerInfo) {
        resolve(JSON.parse(producerInfo));
      } else {
        setTimeout(checkProducerInfo, 100);
      }
    };
    checkProducerInfo();
  });
};

export const visibilityGuard: CanActivateFn = async (route, state) => {
  const modalService = inject(ModalService);
  const routing = inject(Router);
  const serviceTitle = inject(Title);

  const userInfo = await waitForUserInfo();
  const producerInfo = await waitForProducer();
  const path = route.routeConfig?.path;
  let commissionOrBankVisiblity: boolean = false;

  if (!path) {
    return true;
  }

  const visibilityValue = VISIBILITY_MAP.get(path);

  if (!visibilityValue) {
    modalService.showModal(
      new ModalInfos('Attenzione', 'Permesso negato', () => {
        serviceTitle.setTitle('Home | Gestionale Agenzia');
        routing.navigate(['']);
      })
    );
    return false;
  }

  if (visibilityValue === ENUM_VISIBILITY.PROVVIGIONI) {
    commissionOrBankVisiblity = producerInfo
      ? userInfo.userFunctions.includes(ENUM_VISIBILITY.PROVVIGIONI_PRODUTTORE)
      : userInfo.userFunctions.includes(
          ENUM_VISIBILITY.PROVVIGIONI_COASSICURAZIONE
        );

    return commissionOrBankVisiblity;
  } else if (visibilityValue === ENUM_VISIBILITY.ESTRATTICONTO) {
    commissionOrBankVisiblity = producerInfo
      ? userInfo.userFunctions.includes(
          ENUM_VISIBILITY.ESTRATTICONTO_PRODUTTORE
        )
      : userInfo.userFunctions.includes(
          ENUM_VISIBILITY.ESTRATTICONTO_COASSICURAZIONE
        );

    return commissionOrBankVisiblity;
  } else {
    return userInfo.userFunctions?.includes(visibilityValue) ?? false;
  }
};
